class LocalStorageService {
	setItem(key, value) {
        let _item = JSON.stringify(value);
        localStorage.setItem(key, _item);
    }
    getItem(key){
        let _item =  localStorage.getItem(key);
        return (_item != null && _item != undefined && _item != 'undefined') ? JSON.parse(_item): null;
    }
    removeItem(key){
        localStorage.removeItem(key);
    }
}

export default new LocalStorageService();
